module.exports = {"QuotesExpired_Page":{"componentName":"QuotesExpiredPage"}}